export const WishTab = Object.freeze({
  BuyLater: 'buyLater',
  WishProducts: 'wishProducts',
});
